import React, { useEffect, useState } from 'react';
import { Route, HashRouter as Router, Link, Switch } from "react-router-dom"
import SignUp from './signup/signup';
import Login from './login/login';
import Dashboard from './dashboard/dashboard';
import { Socket } from "socket.io-client";
import Complete from './signup/complete';
import ChartForParent from './dashboard/components/chartforparent';
import QuestionExample from './etc/questionexample';
import Login2 from "./login/login2";
import Wordtest from "./etc/wordtest";
import Wordtestreal from "./etc/wordtestreal";
import RegularParentpermit from './etc/regularparentpermit';
import SuddenNoticepermit from './etc/suddennoticepermit';
import SendVoiceText from './etc/sendvoicetext';
import Blank from './dashboard/components/blank';

import "@ionic/react/css/core.css";

// import "@ionic/react/css/normalize.css";
// import "@ionic/react/css/structure.css";
// import "@ionic/react/css/typography.css";-

import "@ionic/react/css/padding.css";
// import "@ionic/react/css/float-elements.css";
// import "@ionic/react/css/text-alignment.css";
// import "@ionic/react/css/text-transformation.css";
// import "@ionic/react/css/flex-utils.css";
// import "@ionic/react/css/display.css";

import "../src/ionictheme/variable.css";

import { useMediaQuery } from "react-responsive";
import MobileLogin from './mobile/login/mobilelogin';
import MobileLogin2 from './mobile/login/mobilelogin2'; 

import { setupIonicReact } from "@ionic/react";
import MobileSignUp from './mobile/signup/mobilesignup';

import MobileCenter from './mobile/center/mobilecenter';
import { Capacitor } from '@capacitor/core';
import DiagnosisForParent from './dashboard/components/diagnosisforparent';

import KioskMain from './kiosk/kioskmain';
import WifiPermitForParent from './etc/wifipermit';
import { ToastContainer } from 'react-toastify';
import AppUrlListener from './mobile/etc/appurllistener';
import TeacherSelectApprove from './etc/teacherselectapprove';
import TeacherSelectReject from './etc/teacherselectreject';
import CoachingReportViewer from './etc/coachingreportviewer';
import RegisterEvent from './etc/registerevent';
import PaymentReceipt from './etc/paymentreceipt';
import MobileSignup2 from './mobile/signup/mobilesignup2';
import MobileFindPassword from './mobile/signup/mobilefindpassword';
import MultipleUserLogin from './mobile/login/multipleuserlogin';
import NewLogin from './mobile/login/newlogin';
import PcNewSignup from './mobile/signup/pcnewsignup';


setupIonicReact();

interface props {
  socket: Socket;
}

const App: React.FC<props> = (appProps) => {

  const [currentScreen, setCurrentScreen] = useState("");
  const isMobile = useMediaQuery({
    query: `(max-width : 1024px)`
  })
  const isNotPc = useMediaQuery({
    query: `(max-width : 1025px)`
  })



  useEffect(() => {
    if (isMobile || Capacitor.isNativePlatform()) {
      setCurrentScreen("mobile");
    } else {
      setCurrentScreen("pc");
    }

  }, [isMobile]);

  useEffect(() => {



  }, []);



  return (

    <>
    <Router>
      {/* <AppUrlListener /> */}
      <Switch>
        <>
          <div id="routing-container">
            <Route exact path="/chartforparent" component={ChartForParent}></Route>
            <Route exact path="/diagnosis" component={DiagnosisForParent}></Route>

            <Route exact path="/" component={currentScreen === "mobile" ? MobileLogin2 : currentScreen === "pc" ? NewLogin : Blank}></Route>
            <Route path="/signup" component={currentScreen === "mobile" ? MobileSignUp : currentScreen === "pc" ? SignUp : Blank}></Route>
            <Route path="/signup2" component={currentScreen === "mobile" ? MobileSignup2 : currentScreen === "pc" ? PcNewSignup : Blank}></Route>
            <Route path="/mobilefindpassword" component={MobileFindPassword}></Route> 
            <Route path="/multipleuserlogin" component={MultipleUserLogin}></Route>
            <Route path="/complete" component={Complete}></Route>
            <Route path="/dashboard" render={(props) => <Dashboard socket={appProps.socket} {...props} />} />
            <Route path="/view/questionexample" component={QuestionExample}></Route>
            <Route path="/login2" component={Login2}></Route>
            <Route path="/wordtest" component={Wordtest}></Route>
            <Route path="/wordtestreal" component={Wordtestreal}></Route>
            <Route path="/regularschedulepermit" component={RegularParentpermit}></Route>
            <Route path="/suddennoticepermit" component={SuddenNoticepermit}></Route>
            <Route path="/wifipermit" component={WifiPermitForParent}></Route>
            <Route path="/teacherselect/approve" component={TeacherSelectApprove}></Route>
            <Route path="/teacherselect/reject" component={TeacherSelectReject}></Route>
            <Route path="/coachingreportviewer" component={CoachingReportViewer}></Route>
            <Route path="/registerevent" component={RegisterEvent}></Route>
            <Route path="/paymentreceipt" component={PaymentReceipt}></Route>

            <Route path="/sendvoicetext" component={SendVoiceText}></Route>

            {/* mobile route */}
            <Route path="/mobiledashboard" render={(props) => <MobileCenter currentScreen={currentScreen} socket={appProps.socket} {...props} />}></Route>

            {/* kiosk route */}
            <Route path="/kiosk" render={(props) => <KioskMain socket={appProps.socket} {...props} />}></Route>
          </div>
        </>
      </Switch>
    </Router>
    <ToastContainer />
    </>

  )
}

export default App;
